export default __webpack_public_path__ + "static/media/profile_pic_grace.be3be68f.png";